var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"120px"}},[_c('h2',{staticStyle:{"margin-top":"40px"}},[_vm._v("Página no existe")])])}]

export { render, staticRenderFns }